export const SPECS = {
  UseCashierConfirmPaymentFn: 'specs.stores.UseCashierConfirmPaymentFn',
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl'
};
//# sourceMappingURL=SPECS.js.map